module.exports = __webpack_public_path__ + "img/like.b6a03341.svg";